
import { RadioChannelType } from "../../radio/data/RadioChannel";
import { APIAdresses } from "../api/APIAdress";
import { APICall } from "../api/APICall";
import { RadioInfoResponse } from "../response/RadioInfoResponse";
import { PHPResponse } from "../../../../library-js/php/PHPResponse";

import { InputData } from "../../../../library-js/php/input/InputData";
import { SongInfo } from "../../radio/data/SongInfo";

export class PlayedSongInfo
{
  channel:string;
  id:string;

  public static create( channel:string, id:string ):PlayedSongInfo
  {
    let info = new PlayedSongInfo();
    info.channel = channel;
    info.id = id;

    return info;
  }
}


export class RadioNextSongInput extends InputData
{
  played:PlayedSongInfo[];
  channel:RadioChannelType;
}

export class SongInfoResponse extends PHPResponse
{
  songInfo:SongInfo;  
}


export class RadioNextSong extends APICall<RadioNextSongInput,SongInfoResponse>
{
  static readonly ADRESS = APIAdresses.RADIO_NEXT_SONG;

  constructor(){ super( RadioNextSong.ADRESS ); }
  
}